const MENSUAL = 'M'
const ANUAL = 'A'
const NINGUNO = 'N'

const __dictionary = {
  [MENSUAL]: {
    id: MENSUAL,
    nombre: 'MENSUAL'
  },
  [ANUAL]: {
    id: ANUAL,
    nombre: 'ANUAL'
  },
  [NINGUNO]: {
    id: NINGUNO,
    nombre: 'NINGUNO'
  }
}

const __array = [__dictionary[MENSUAL], __dictionary[ANUAL], __dictionary[NINGUNO]]

export default Object.freeze({
  MENSUAL,
  ANUAL,
  NINGUNO,
  __dictionary,
  __array
})
